import axios from "axios";

// Use relative URL for production (when BACKEND_URL is not set or same domain)
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

// Configure axios defaults
axios.defaults.withCredentials = true;

// Authentication is handled via httpOnly cookies - no localStorage token needed

export default axios;
